import { Box } from '@src/components/Core';
import { values } from 'lodash-es';
import { useEffect, useMemo } from 'react';
import { map } from 'rxjs';
import { useSocketPerformance } from '../../providers';
import { BlotterTable, useBlotterTable, type Column } from '../BlotterTable';
interface ErroredStreamsBlotterProps {
  onShowMessages: (messages: { reqid: string; messages: string }) => void;
  filterText: string;
}

export function ErroredStreamsBlotter(props: ErroredStreamsBlotterProps) {
  const { filterText } = props;
  const performance = useSocketPerformance();
  const columns: Column[] = useMemo(() => {
    return [
      {
        field: 'reqId',
        headerName: 'Request ID',
        type: 'text',
      },
      {
        field: 'sub',
        headerName: 'Subscription',
        type: 'text',
      },
      {
        field: 'tag',
        headerName: 'Tag',
        type: 'text',
      },
      {
        field: 'erroredMessages.0.error.msg',
        type: 'text',
      },
    ];
  }, []);

  const dataObservable = useMemo(
    () => performance.stats().pipe(map(stats => ({ data: values(stats.streamErrorStats) }))),
    [performance]
  );

  const blotterTable = useBlotterTable({
    dataObservable,
    errorObservable: undefined,
    columns,
    rowID: 'reqId',
  });

  useEffect(() => {
    blotterTable.blotterTableFiltersProps.onQuickFilterTextChanged(filterText);
  }, [filterText, blotterTable]);

  return (
    <Box h="70vh" w="1200px" gap="spacing2" overflow="hidden">
      <BlotterTable {...blotterTable} />;
    </Box>
  );
}
